/**
 * Formato de montos y monedas.
 *
 * Un solo lugar para decidir cómo se escribe la plata, porque antes cada
 * pantalla lo resolvía por su cuenta: el preview de la factura armaba los
 * separadores a mano con un regex y salía "VES 2,055.00", mientras el resto
 * de la app usaba Intl y salía "2.055,00". Dos formatos distintos para el
 * mismo monto.
 *
 * Dos reglas que vienen de cómo se factura en Venezuela:
 *  - En una factura se escribe "Bs.", no "VES". VES es el código ISO 4217,
 *    de uso bancario e internacional; un contador venezolano no lo reconoce
 *    en un documento fiscal.
 *  - Los separadores son punto para miles y coma para decimales: 2.055,00.
 */

// Cómo se escribe cada moneda en un documento. Solo VES cambia respecto al
// código ISO: el resto se deja tal cual porque "USD" o "EUR" no se prestan a
// confusión, mientras que "$" sí (lo usan tanto el dólar como el peso).
const SIMBOLOS = {
  VES: 'Bs.',
  USD: 'USD',
  EUR: 'EUR',
  COP: 'COP'
};

export const MONEDA_POR_DEFECTO = 'VES';

/** Devuelve cómo se escribe una moneda: 'VES' → 'Bs.' */
export const simboloMoneda = (moneda) => SIMBOLOS[moneda] || moneda || SIMBOLOS[MONEDA_POR_DEFECTO];

/**
 * Formatea un número con separadores venezolanos: 1234567.89 → "1.234.567,89"
 * Siempre con dos decimales, que es lo que corresponde en una factura.
 */
export const formatearMonto = (valor) => {
  const numero = Number(valor);
  return new Intl.NumberFormat('es-VE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(Number.isFinite(numero) ? numero : 0);
};

/**
 * Monto con su moneda, listo para imprimir: (2055, 'VES') → "Bs. 2.055,00"
 */
export const formatearMoneda = (valor, moneda = MONEDA_POR_DEFECTO) =>
  `${simboloMoneda(moneda)} ${formatearMonto(valor)}`;
